import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import FormInfoBookingOrder from '../../../components/FormInfo/BookingOrder/FormInfo';
import config from '../../../utils/config';
import { DownloadButton, QrCodeWrapper } from '../../../components/FormInfo/BookingOrder/styled';
import { FORM_INFO_COMPONENT_TYPES, FORM_INFO_TYPES } from '../../../components/FormInfo/types';
import { isAndroid, isiOS, replaceVariables } from '../../../utils';
import { WarningImageContainer } from '../../../components/FormInfo/BookingHandling/styled';

const BrowserNotSupported = () => {
  const type = FORM_INFO_TYPES.BROWSER_NOT_SUPPORTED;
  const { title, body } = FORM_INFO_COMPONENT_TYPES[type];

  const isDeviceiOS = isiOS();
  const isDeviceAndroid = isAndroid();
  return (
    <FormInfoBookingOrder
      type={type}
      title={title}
      body={replaceVariables(body, {
        downloadMethod: !isDeviceAndroid && !isDeviceiOS ? ' by scanning the QR code below with your phone’s camera' : ''
      })}
      aboveTitleElement={
        <WarningImageContainer>
          <StaticImage src="../../../images/warning.png" alt="warning" width={60} height={60} quality={100} formats={['webp']} loading="eager" />
        </WarningImageContainer>
      }
    >
      {isDeviceiOS || isDeviceAndroid ? (
        <DownloadButton target="_blank" href={isDeviceiOS ? config.APP_IOS_URL : config.APP_ANDROID_URL}>
          Download
        </DownloadButton>
      ) : (
        <QrCodeWrapper>
          <StaticImage src="../../../images/qrCode.png" alt="Qr code" quality={100} loading="eager" formats={['webp']} />
        </QrCodeWrapper>
      )}
    </FormInfoBookingOrder>
  );
};
export default BrowserNotSupported;
